var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock 1",
    clipPath: "url(#clip0_0_10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0001 31.9844C1.79775 31.9701 -5.34599 14.7222 4.68649 4.67068C10.642 -1.53562 21.3583 -1.53662 27.3138 4.67093C37.3462 14.7233 30.2016 31.9709 16.0001 31.9844ZM16.0001 2.48443C8.55617 2.48443 2.50012 8.54048 2.50012 15.9844C3.24168 33.8939 28.7612 33.8887 29.5001 15.9843C29.5001 8.54055 23.444 2.48443 16.0001 2.48443ZM21.8215 20.038L17.8722 16.0888C17.907 15.5055 17.6582 14.9481 17.2495 14.5863C17.2498 14.5733 17.2501 14.5602 17.2501 14.547V7.23449C17.1841 5.57599 14.8155 5.57724 14.7501 7.23449V14.547C14.7501 14.5602 14.7503 14.5733 14.7507 14.5863C13.4435 15.7565 14.3303 17.948 16.1044 17.8566L20.0536 21.8058C20.5418 22.294 21.3333 22.294 21.8214 21.8058C22.3096 21.3176 22.3096 20.5262 21.8215 20.038Z",
    fill: "var(--fill-0, #ACACAC)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e37e6de4083bb37f7cf49622af5b0d1f.svg";
export { ForwardRef as ReactComponent };